/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { WINDOW } from '../helpers/window.injectToken'

@Injectable()
export class PidxHrefClickHandlerService {
  private router = inject(Router)
  private window = inject<Window>(WINDOW)

  constructor() {
    this.window.addEventListener('click', (event) => this.handleClickEvent(event))
  }

  handleClickEvent(event: MouseEvent) {
    let href: string | null = null
    let target: Node | null = event.target as Node
    do {
      if (target instanceof HTMLAnchorElement && target.href) {
        href = target.href
      }
      target = target.parentElement
    } while (!href && !!target)

    if (href && href !== '#' && href !== 'javascript:void(0);' && href.indexOf('/myprofile/') !== -1) {
      event.preventDefault()
      const strippedHref = href.replace('/myprofile', '')
      const pathname = new URL(strippedHref).pathname

      this.router.navigateByUrl(pathname).catch(() => {
        this.window.location.assign(strippedHref)
      })
    }
  }
}
